import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetCloud: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M20 16.58A5 5 0 0018 7h-1.26A8 8 0 104 16.25" />
      </svg>
    </div>
  );
};

export default WidgetCloud;
